import React, { useEffect, useState } from 'react';

import { getAnalyticsData, setCookies, COOKIE_AGREE_DEFAULT_TIMEOUT, COOKIE_AGREE, isCookieSet } from 'helpers';

interface Props {
  toggleToggles: () => void;
}

export const CookiesAgreement = ({ toggleToggles }: Props) => {
  const [cookieAgreeIsSet, setCookieAgree] = useState<boolean>(true);

  const checkCookieIsSet = (): boolean => {
    return isCookieSet(COOKIE_AGREE);
  };

  useEffect(() => {
    const result = checkCookieIsSet();

    setCookieAgree(result);
  }, [cookieAgreeIsSet]);

  useEffect(() => {
    async function updateAnalyticsData() {
      const analyticsData = await getAnalyticsData();

      (window as any).dataLayer?.push({
        event: 'route_changed',
        ...analyticsData,
      });
    }

    updateAnalyticsData();
  }, []);

  const handleAgreeButtonPress = () => {
    setCookies(COOKIE_AGREE, 'true', { maxAge: COOKIE_AGREE_DEFAULT_TIMEOUT, sameSite: 'lax', secure: true });
    setCookieAgree(true);
    toggleToggles();
  };

  if (cookieAgreeIsSet) return null;

  return (
    !cookieAgreeIsSet && (
      <div className="privacy-cookies-container" id="cookie-agreement-banner" key="cookie-agreement-banner">
        <div className="privacy-cookies-content">
          <p className="privacy-cookies-agreement-paragraph">
            This website uses cookies to enhance your experience and for web analytics purposes. Read our{' '}
            <a href="/privacy-notice#main-dif">Privacy notice</a> to learn more or{' '}
            <a href="/privacy-notice#cookie-dif">to change your cookie preferences</a>. By continuing to browse the
            site, you agree to our use of cookies.
          </p>
        </div>
        <div className="privacy-cookies-button-wrapper">
          <button
            type="button"
            className="privacy-cookies-button"
            id="rcc-confirm-button"
            aria-label="Accept cookies"
            onClick={() => handleAgreeButtonPress()}
          >
            I agree
          </button>
        </div>
      </div>
    )
  );
};
